/**
 * Initialize diffent component resources
 */

import * as registry from "@qpr/client-api-registry";

import AllKPIGraphIcon2 from "assets/AllKPIGraphIcon";
import { ReactComponent as MobileIconOutlined } from "assets/MobileIconOutlined.svg";
import LandingPageBackground from "assets/Logo.png";
import icon1 from "mockIcons/1.svg";
/**
 * Search results
 *
 * Usage: registry.get('emptyMultiDonutChart)
 */
registry.add({
  searchResultsIconSVG: icon1,
  LandingPageBackground,
});

registry.addSvgIcon({
  AllKPIGraphIcon: AllKPIGraphIcon2,
});

registry.addSvg({
  MobileIconOutlined,
});
